import { render, staticRenderFns } from "./MailEditModal.vue?vue&type=template&id=1cf1ede8&"
import script from "./MailEditModal.vue?vue&type=script&lang=js&"
export * from "./MailEditModal.vue?vue&type=script&lang=js&"
import style0 from "./MailEditModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports